document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.quiz-card');
  const elRespondidas = document.getElementById('quiz-respondidas');
  const elAcertos = document.getElementById('quiz-acertos');
  const btnReset = document.getElementById('quiz-reset');
  const totalCards = cards.length;
  let respondidas = 0;
  let acertos = 0;

  cards.forEach(function (card) {
    const tipoCorreto = card.getAttribute('data-tipo');
    const botoes = card.querySelectorAll('.quiz-btn');
    const badge = card.querySelector('.quiz-resultado-badge');

    botoes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (card.classList.contains('respondido')) return;

        const resposta = btn.getAttribute('data-resposta');
        const acertou = resposta === tipoCorreto;

        card.classList.add('respondido');
        card.classList.add(acertou ? 'acertou' : 'errou');

        // Marca o botão escolhido e o correto
        btn.classList.add('escolhido');
        card.querySelector('.quiz-btn-' + tipoCorreto).classList.add('correto');

        // Badge de resultado
        const ehMito = tipoCorreto === 'mito';
        badge.classList.add(ehMito ? 'badge-mito' : 'badge-verdade');
        badge.innerHTML = (acertou ? '<i class="fas fa-check"></i> Você acertou! ' : '<i class="fas fa-times"></i> Não é bem assim. ')
                        + 'Isso é um <strong>' + (ehMito ? 'Mito' : 'Verdade') + '</strong>.';

        // Atualiza placar
        respondidas++;
        if (acertou) acertos++;
        elRespondidas.textContent = respondidas;
        elAcertos.textContent = acertos;

        if (respondidas === totalCards) {
          btnReset.style.display = 'inline-flex';
        }
      });
    });
  });

  if (btnReset) {
    btnReset.addEventListener('click', function () {
      respondidas = 0; acertos = 0;
      elRespondidas.textContent = '0';
      elAcertos.textContent = '0';
      btnReset.style.display = 'none';
      cards.forEach(function (card) {
        card.classList.remove('respondido', 'acertou', 'errou');
        card.querySelectorAll('.quiz-btn').forEach(function (b) {
          b.classList.remove('escolhido', 'correto');
        });
        const badge = card.querySelector('.quiz-resultado-badge');
        badge.className = 'quiz-resultado-badge';
        badge.innerHTML = '';
      });
      document.getElementById('mitos').scrollIntoView({ behavior: 'smooth' });
    });
  }
});
